import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import moment from 'moment'
import {
  Row, Col, Upload, Input,
} from 'antd'
import {
  Div, P, Loading, Button,
} from 'konsys-ui'
import { CREATE_BILL, UPDATE_BILL } from '../../../constants/graphql/mutation'
import { theme } from '../../../styles/_variables'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { BILL_INFO } from '../../../constants/graphql/query'
import { ActionBar, PaidInfo } from '../../../components/bill-components'
import history from '../../../history'

const { color } = theme

const DetailWithTable = ({
  invoiceList, params, onChangeHandler, billData, isUpdateMode, isViewMode, mutationVariables, setMutationVariables, data,
}) => (
    <Div>
      {detailType(params, onChangeHandler, billData, mutationVariables)}
      {billData.status === 'PAID' && <PaidInfo billData={billData} isViewMode={true} onChangeHandler={onChangeHandler} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} data={data}/>}
      <Div style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        <Row align='flex-start' type='flex' gutter={4} style={{ margin: '32px 0' }}>
          <Col span={3} offset={1}><P bold>เลขที่ใบวางบิล / ใบแจ้งหนี้</P></Col>
          <Col span={3}><P bold>เลขที่สัญญางาน</P></Col>
          <Col span={3}><P bold>วันที่ครบกำหนดชำระ</P></Col>
          <Col span={3}><P bold>จำนวนเงิน</P></Col>
          <Col span={3}><P bold>จำนวน shipment</P></Col>
        </Row>
        {
          // TODO Top re-check
          _.isEmpty(invoiceList)
            ? <P>ไม่มีข้อมูล</P>
            : _.map(invoiceList, (v, i) => <Row>
              <Col span={1} style={{ margin: '0 0 16px' }}><P>{i + 1}</P></Col>
              <Col span={3} style={{ margin: '0 0 16px' }}><P>{_.isEmpty(v.refId) ? '-' : v.refId}</P></Col>
              <Col span={3} style={{ margin: '0 0 16px' }}><P>{_.isEmpty(v.Job?.number) ? '-' : v.Job?.number}</P></Col>
              <Col span={3} style={{ margin: '0 0 16px' }}><P>{_.isEmpty(v.dueDate) ? '-' : moment(v.dueDate).format('DD/MM/YYYY')}</P></Col>
              <Col span={3} style={{ margin: '0 0 16px' }}><P>{v.shippingGrandTotal ? parseFloat(v.shippingGrandTotal).toFixed(2) : '-'}</P></Col>
              <Col span={3} style={{ margin: '0 0 16px' }}><P>{v.shippings ? v.shippings.length : '-'}</P></Col>
            </Row>)
        }
        <Row align='flex-start' type='flex' style={{ margin: '32px 0' }}>
          <Col span={3} offset={1}><P bold>ยอดรวมทั้งสิ้น</P></Col>
          <Col span={3} offset={3}><P>฿ {_.reduce(invoiceList, (sum, v) => (sum + parseFloat(parseFloat(v.shippingGrandTotal).toFixed(2))), 0).toFixed(2)}</P></Col>
          <Col span={3}><P>{_.reduce(invoiceList, (sum, v) => (sum + parseFloat(v.shippings.length)), 0)}</P></Col>
        </Row>
      </Div>
      <Div style={{ borderBottom: `1px solid ${color.paleGrey}`, padding: '32px 0' }}>
        <Row>
          <Col
            span={12}
            style={{ alignSelf: 'flex-end' }}
          >
            <Div display='flex' flexDirection='column'>
              <P margin='0 0 16px'>หมายเหตุ</P>
              <Input.TextArea row={4} disabled={isViewMode} defaultValue={billData.remark} onChange={e => onChangeHandler('remark', e.target.value)}/>
            </Div>
          </Col>
        </Row>
      </Div>
    </Div>
)

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isUpdateMode = props.match.params.mode.toUpperCase() === detailMode.EDIT
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  if (_.isUndefined(props.location.state) && isAddMode) {
    history.push('/bill')
    return null
  }

  const { state } = props.location
  const [mutationVariables, setMutationVariables] = useState(
    isAddMode ? {
      createdDate: moment().format(),
      dueDate: moment().add(state.invoices[0].Job.Customer.credit, 'd').format(),
      jobId: state.invoices[0].Job.id,
      invoicesId: state.invoices.map(v => v.id),
    } : {},
  )

  let onChangeHandler = (id, value) => {
    if (id === 'createdDate') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        dueDate: moment(value).add(state.invoices[0].Job.Customer.credit, 'd').format(),
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? <Div>
              <DetailWithTable
                invoiceList={props.location.state.invoices}
                mutationVariables={mutationVariables}
                params={props.match.params}
                onChangeHandler={onChangeHandler}
                billData={{
                  jobCode: state.invoices[0].Job.jobCode,
                  jobVolume: state.invoices[0].Job.volumn,
                  jobNumber: state.invoices[0].Job.number,
                  jobDealType: state.invoices[0].Job.dealType,
                  companyId: state.invoices[0].Job.Customer.companyId,
                  companyName: state.invoices[0].Job.Customer.companyName,
                  branch: state.invoices[0].Job.Customer.branch,
                  typeOfChargeName: state.invoices[0].Job.Customer.TypeOfCharge.name,
                  credit: state.invoices[0].Job.Customer.credit,
                }}
                isUpdateMode={isUpdateMode}
                isViewMode={isViewMode}
                setMutationVariables={setMutationVariables}
              />
              <Mutation
                  mutation={CREATE_BILL} // TODO Mutation create
              >{(doAction, resp) => (
                  <ActionBar
                    loading={resp.loading}
                    isAddMode={isAddMode}
                    isViewMode={isViewMode}
                    doAction={doAction}
                    mutationVariables={{
                      ...mutationVariables,
                    }}
                    props={props}
                    disabled={_.isUndefined(mutationVariables.createdDate) || mutationVariables.createdDate === 'Invalid date'
                      || _.isUndefined(mutationVariables.dueDate) || mutationVariables.dueDate === 'Invalid date'
                      || !moment(mutationVariables.dueDate).isAfter(moment(mutationVariables.createdDate))}
                  />
              )}
              </Mutation>
            </Div>
          : <Query
              query={BILL_INFO}
              variables={{ id: props.match.params.id }}
            >{({ data, error, loading }) => {
              if (loading && _.isEmpty(data)) return <Loading center='true' />
              if (error) return <P>เกิดข้อผิดพลาด</P>
              onChangeHandler = (id, value) => {
                setMutationVariables({
                  createdDate: data.BillInfo.createdDate,
                  dueDate: data.BillInfo.dueDate,
                  ...mutationVariables,
                  [id]: value,
                })
              }
              const billData = {
                ...data.BillInfo,
                jobCode: data.BillInfo.Job.jobCode,
                jobVolume: data.BillInfo.Job.volumn,
                jobNumber: data.BillInfo.Job.number,
                jobDealType: data.BillInfo.Job.dealType,
                companyId: data.BillInfo.Job.Customer.companyId,
                companyName: data.BillInfo.Job.Customer.companyName,
                branch: data.BillInfo.Job.Customer.branch,
                typeOfChargeName: data.BillInfo.Job.Customer.TypeOfCharge.name,
              }
              const invoiceList = data.BillInfo.invoices
              return (
                <Div>
                  <DetailWithTable isViewMode={isViewMode} invoiceList={invoiceList} params={props.match.params} onChangeHandler={onChangeHandler} billData={billData} isUpdateMode={isUpdateMode} mutationVariables={mutationVariables} setMutationVariables={setMutationVariables} data={data}/>
                  <Mutation
                    mutation={isAddMode ? CREATE_BILL : UPDATE_BILL}
                  >{(doAction, resp) => (
                    <ActionBar
                      loading={resp.loading}
                      isAddMode={isAddMode}
                      isViewMode={isViewMode}
                      doAction={doAction}
                      mutationVariables={{ ...mutationVariables }}
                      props={props}
                      bill={data.BillInfo}
                      invoices={data.BillInfo.invoices}
                      volumeNumber={data.BillInfo.Job}
                      disabled={isUpdateMode
                        && (_.isUndefined(mutationVariables.createdDate) || mutationVariables.createdDate === 'Invalid date'
                        || _.isUndefined(mutationVariables.dueDate) || mutationVariables.dueDate === 'Invalid date'
                        || !moment(mutationVariables.dueDate).isAfter(moment(mutationVariables.createdDate)))}
                    />
                  )}
                  </Mutation>
                </Div>
              )
            }}
            </Query>
      }
    </Div>
  )
}

export default Index
export { Index }
